/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function customCss
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */

import videojs from 'video.js';
import utils from './utils.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;

// Default options for the plugin.
const defaults = {
    url: '',
    classPrefix: 'vjs-skin-',
    className: ''
};

/**
 * Function to load CSS file and set given CSS class to player.
 *
 * Load css file and add CSS class to player.
 * CSS class name resolves as 'className' argument passed via options or as 'classPrefix' + part of 'url' after last '_' simbol if such part is presented in url. 
 * Otherwise it's empty.
 *
 * @function applayCss
 * @param    {Player} player
 * @param    {Object} options
 * @param    {String} [options.url='']                        - Url to load CSS
 * @param    {String} [options.classPrefix='vjs-skin-']       - Prefix for CSS class, added to player
 * @param    {String} [options.className='']                  - Name for CSS class, added to player
 */

const applayCss = (player, {url, classPrefix, className}) => {
    if (!url) return;
    utils.loadCss(url);

    let skin_name = url.replace(/^.*_/, '').replace(/\..*/, ''); // skin name - part after last '_' of url
    player.addClass(className || (skin_name ? classPrefix + skin_name : ''));
};

const customCss = function(options) {
    applayCss(this, videojs.mergeOptions(defaults, options));
};

registerPlugin('customCss', customCss);

export default customCss;

